import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, AfterViewInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'trg-card-list-item',
  templateUrl: './trg-card-list-item.component.html',
  styleUrls: ['./trg-card-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SharedTrgCardListItemComponent implements AfterViewInit {
  @Input() selected = false;
  @Input() selectable = true;

  @ViewChild('cardHeaderRef') cardHeaderRef: ElementRef;
  @ViewChild('cardBodyRef') cardBodyRef: ElementRef;
  @ViewChild('cardFooterRef') cardFooterRef: ElementRef;

  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  hasHeaderContent() {
    return this.cardHeaderRef && this.cardHeaderRef.nativeElement.childNodes.length > 0;
  }

  hasBodyContent() {
    return this.cardBodyRef && this.cardBodyRef.nativeElement.childNodes.length > 0;
  }

  hasFooterContent() {
    return this.cardFooterRef && this.cardFooterRef.nativeElement.childNodes.length > 0;
  }
}
